<template>
  <message>
    <template slot="icon">
      <i class="far fa-calendar-check text-success" style="font-size: 100px" />
    </template>
    <template slot="text">
      <h3 class="text-success p-t-20">{{ $t('revision-confirm.title').toUpperCase() }}</h3>
    </template>
    <template slot="bottom">
      <i class="fa fa-mobile-alt pr-2" />{{ $t('revision-confirm.notification') }}
      <div class="column col-12 col-lg-12">
        <div class="modified-alert">
          <i class="fa fa-exclamation-circle pr-2" />{{ $t('revision-confirm.content') }}
        </div>
      </div>
    </template>
  </message>
</template>
<script>
import Message from '@/components/dialog/Message'

export default {
  name: 'RevisionConfirm',
  components: {
    Message,
  },
}
</script>
